import safeFetch from '../../utils/safeFetch';
import getQuoteIdFromUrl from './getQuoteIdFromUrl';

const removeItemToUrl = (url, requestData) => {
  return new Promise((resolve, reject) => {
    getQuoteIdFromUrl(window.getQuoteIdUrl)
      .then((quoteId) => {
        safeFetch(url, {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ ...requestData, quoteid: quoteId }),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then((data) => {
            if (!data) {
              reject({
                message: `No response after call getQuoteIdFromUrl (${window.getQuoteIdUrl})`,
              });
            } else {
              resolve({ data });
            }
          })
          .catch((error) =>
            reject({ message: `Response after call removeItemUrl (${url}) failed: ${error}` }),
          );
      })
      .catch((error) => reject(error));
  });
};

export default removeItemToUrl;
